import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactNode, useEffect, useState } from 'react'
import { createQueryClient } from './createQueryClient'

interface ReactQueryProviderProps {
  children: ReactNode
  organisationId?: string
}

export function ReactQueryProvider({ children, organisationId }: ReactQueryProviderProps) {
  const [queryClient] = useState(() => createQueryClient())

  useEffect(() => {
    // Scoped by org so a cached query result never broadcasts across a user's tabs open on
    // different organisations (query keys like requestId aren't org-scoped on the client).
    if (!organisationId) return

    const unsubscribe = broadcastQueryClient({
      queryClient,
      broadcastChannel: `${process.env.OMNEA_APP_ENV}-${organisationId}-omnea-broadcast-channel`,
    })
    return () => {
      unsubscribe()
    }
  }, [queryClient, organisationId])

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" position="bottom" />
      {children}
    </QueryClientProvider>
  )
}
